import { useCallback, useEffect, useState } from 'react'

// Owner-only debug toggle: should AI provider names (gemini / groq /
// cerebras) appear next to AI responses around the app?
//
// Normal users should never see these — they're implementation
// detail. The owner can flip this in Settings → Developer to confirm
// which provider the LLM router fell through to during debugging.
// Stored in localStorage; default false so the toggle starts off
// even for the owner.

const STORAGE_KEY = 'phoenix:show-ai-provider'
const EVENT = 'phoenix:show-ai-provider-changed'

function read() {
  try { return localStorage.getItem(STORAGE_KEY) === 'true' } catch { return false }
}

export function useShowAiProvider() {
  const [enabled, setEnabled] = useState(read)

  // Sync across components mounted in different parts of the tree.
  // The Settings toggle and the AssistantSheet (rendered in a portal
  // at App level) both need to react to changes in the same tab.
  useEffect(() => {
    const onChange = () => setEnabled(read())
    window.addEventListener(EVENT, onChange)
    window.addEventListener('storage', onChange)
    return () => {
      window.removeEventListener(EVENT, onChange)
      window.removeEventListener('storage', onChange)
    }
  }, [])

  const setShowProvider = useCallback((next) => {
    try { localStorage.setItem(STORAGE_KEY, next ? 'true' : 'false') } catch { /* */ }
    setEnabled(!!next)
    window.dispatchEvent(new Event(EVENT))
  }, [])

  return { enabled, setShowProvider }
}
